import React, {useEffect, useState} from "react";
import {getProeveresultater, getUtenlandskeProeveResultater} from "../api";
import Proever from "../components/Proever";
import {withRouter} from "react-router-dom";

const ProeverContainer = (props) => {
    const { id } = props.match.params;
    const hund = props.hund;
    const {proeveresultater} = useFetchProeveresultater(hund.hundId, id);
    const {utenlandskeResultater} = useFetchUtenlandskeResultater(hund.hundId, id);
    
    return (
        <Proever    hund={hund}
                    jaktresultater={proeveresultater[0]}
                    bruksresultater={proeveresultater[1]}
                    aktivitetsresultater={proeveresultater[2]}
                    utenlandskeResultater={utenlandskeResultater}
        />
    );
};



const useFetchProeveresultater = (hundId, id) => {
    const initRes = [[], [], []];
    const [proeveresultater, setProeveresultater] = useState(initRes);
    const [isProeveresultaterLoading, setIsProeveresultaterLoading] = useState(false);
    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsProeveresultaterLoading(true);
            }
            getProeveresultater(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let jakt = [];
                        let bruk = [];
                        let aktivitet = []
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].kategori === 'JAKT') {
                                jakt.push(data[i]);
                            } else if (data[i].kategori === 'BRUKSPROEVE') {
                                bruk.push(data[i]);
                            } else if (data[i].kategori === 'AKTIVITET') {
                                aktivitet.push(data[i]);
                            }
                        }
                        setProeveresultater([jakt, bruk, aktivitet]);
                        setIsProeveresultaterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsProeveresultaterLoading(false);
                        setProeveresultater(null);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { proeveresultater, isProeveresultaterLoading };
};

const useFetchUtenlandskeResultater = (hundId, id) => {
    const [utenlandskeResultater, setUtenlandskeResultater] = useState([]);
    const [isUtenlandskeResultaterLoading, setIsUtenlandskeResultaterLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsUtenlandskeResultaterLoading(true);
            }
            getUtenlandskeProeveResultater(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let resultater = [];
                        for (var i = 0; i < data.length; i++) {
                            resultater.push(data[i]);
                        }
                        setUtenlandskeResultater(resultater);
                        setIsUtenlandskeResultaterLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsUtenlandskeResultaterLoading(false);
                        setUtenlandskeResultater(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { utenlandskeResultater, isUtenlandskeResultaterLoading };
};



export default withRouter(ProeverContainer);
